import { atom, useAtom } from 'jotai';
import { DeliveriesFilters, DeliveriesSortField } from 'api/models/Deliveries';
import { SortOrder } from 'api/models/Sorting';

export const ACTION_ITEMS_INITIAL_FILTERS: DeliveriesFilters = {
  sort_order: SortOrder.Ascending,
  sort_by: DeliveriesSortField.SurgeryDate,
};

const actionItemsFiltersAtom = atom(ACTION_ITEMS_INITIAL_FILTERS);

export const useActionItemsFilters = () => useAtom(actionItemsFiltersAtom);
